// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Style the lead quote list container */
.lead-quote-list-container {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 1rem;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Style the header of the lead quote list */
.lead-quote-list-header {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
}

.lead-quote-list-header tr {
  text-align: center;
}

/* Style the table within the lead quote list */
.lead-quote-list-container table {
  width: 100%;
  border-collapse: collapse;
}

/* Style the table header */
.lead-quote-list-container th {
  background-color: #f5f5f5;
  padding: 8px;
  border: 1px solid #ccc;
  font-size: 2rem;
}

/* Style the table body */
.lead-quote-list-container td {
  padding: 8px;
  border: 1px solid #ccc;
}

/* Style the action buttons in each row */
.lead-quote-list-container button {
  padding: 5px 10px;
  margin-right: 5px;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
}

/* Style the edit button */
.create-new-quote-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

/* Create Quote Button */
.create-new-quote-btn {
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  background-color: #22c55e;
  color: white;
  font-size: 2rem;
  font-weight: bold;
  margin-top: 2rem;
}

.lead-quote-list-container .detailsButton {
  padding: 8px 16px;
  background-color: #247a97;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.lead-quote-list-container .detailsButton:hover {
  background-color: #22c55e;
}

.lead-quote-list-container .cat-container {
  color: #247a97;
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: #f3f4f6;
  padding: 8px;
  border-radius: 8px;
}

@media screen and (max-width: 991px) {
  .lead-quote-list-container table {
    width: 80%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/LeadQuoteList.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["/* Style the lead quote list container */\n.lead-quote-list-container {\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-top: 1rem;\n  background-color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Style the header of the lead quote list */\n.lead-quote-list-header {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.lead-quote-list-header tr {\n  text-align: center;\n}\n\n/* Style the table within the lead quote list */\n.lead-quote-list-container table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n/* Style the table header */\n.lead-quote-list-container th {\n  background-color: #f5f5f5;\n  padding: 8px;\n  border: 1px solid #ccc;\n  font-size: 2rem;\n}\n\n/* Style the table body */\n.lead-quote-list-container td {\n  padding: 8px;\n  border: 1px solid #ccc;\n}\n\n/* Style the action buttons in each row */\n.lead-quote-list-container button {\n  padding: 5px 10px;\n  margin-right: 5px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n/* Style the edit button */\n.create-new-quote-btn-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n/* Create Quote Button */\n.create-new-quote-btn {\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  cursor: pointer;\n  background-color: #22c55e;\n  color: white;\n  font-size: 2rem;\n  font-weight: bold;\n  margin-top: 2rem;\n}\n\n.lead-quote-list-container .detailsButton {\n  padding: 8px 16px;\n  background-color: #247a97;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.lead-quote-list-container .detailsButton:hover {\n  background-color: #22c55e;\n}\n\n.lead-quote-list-container .cat-container {\n  color: #247a97;\n  font-size: 1.75rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  background-color: #f3f4f6;\n  padding: 8px;\n  border-radius: 8px;\n}\n\n@media screen and (max-width: 991px) {\n  .lead-quote-list-container table {\n    width: 80%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
